import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnControlType,
  ApDynGridColumnHideConfig,
  IPipeDefinition
} from './ap-dyn-grid-column-config-base';
import {ApIconType} from '../../icons/ap-icon-type';

/**
 * DynGrid config which allows embedding icons within our grid.
 * To see all available icons see class ApIconSelectorComponent.ts
 */
export class ApDynGridIconColumnConfig extends ApDynGridColumnConfigBase {

  public type = ApDynGridColumnControlType.Icon;
  public title: string;
  public tooltip: (dataItem: any) => string;
  /**
   * The unique icon id. See ApIconSelectorComponent.ts to find all available id's
   */
  public icon: (dataItem: any) => ApIconType;
  /**
   * Custom css class for styling the icon
   */
  public iconClass: (dataItem: any) => string;

  constructor(options: {
    hide?: boolean | ApDynGridColumnHideConfig,
    sortIndex?: number,
    sortDesc?: boolean,
    groupIndex?: number,
    groupDesc?: boolean,
    headerStyle?: any,
    style?: any,
    width?: number,
    pdfExport?: boolean,
    xlsExport?: boolean,
    enable?: boolean,
    cssClass?: 'left' | 'right' | 'center',
    dynCssClass?: (dataItem: any) => string,
    pipes?: IPipeDefinition[],
    tooltipPipes?: IPipeDefinition[],
    defaultFilter?: any,
    field?: string,
    sortable?: boolean,
    title?: string,
    tooltip?: (dataItem: any) => string,
    iconClass?: (dataItem: any) => string
    icon?: (dataItem: any) => ApIconType
  }) {
    super(options);
    this.title = options.title ? options.title : ' ';
    this.iconClass = options.iconClass ?
      (dataItem) => dataItem === undefined ?
        undefined : options.iconClass(dataItem) : () => undefined;
    this.icon = options.icon ?
      (dataItem) => dataItem === undefined ?
        undefined : options.icon(dataItem) : () => undefined;
    this.tooltip = options.tooltip ? super.getTooltip(options.tooltip) : () => undefined;
  }

}
